import { Component, OnDestroy, OnInit } from '@angular/core';
import { JhiAlertService } from 'app/ng-jhipster/service';

@Component({
  selector: 'jhi-alert',
  template: `
    <div class="alerts" role="alert">
      @for (alert of alerts; track alert) {
        <div [ngClass]="setClasses(alert)">
          @if (alert && alert.type && alert.msg) {
            <ngb-alert [type]="alert.type" (close)="alert.close(alerts)">
              <pre [innerHTML]="alert.msg"></pre>
            </ngb-alert>
          }
        </div>
      }
    </div>
  `,
  standalone: false,
})
export class JhiAlertComponent implements OnInit, OnDestroy {
  alerts: any[];

  constructor(private alertService: JhiAlertService) {}

  ngOnInit() {
    this.alerts = this.alertService.get();
  }

  setClasses(alert) {
    return {
      'jhi-toast': alert.toast,
      [alert.position]: true,
    };
  }

  ngOnDestroy() {
    this.alerts = [];
  }
}
